import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  Row, Col,
} from 'reactstrap';

import { deleteLabOrderAttachmentRequest, deleteLabOrderMessageAttachmentRequest } from '@reducers/lab-order/LabOrderAction';
import { deleteReferralMessageAttachmentRequest, deleteReferralAttachmentRequest } from '@reducers/referral/ReferralAction';
import { handleError } from '@services/ErrorHandler';
import LocaleService from '@services/LocaleService';
import { CustomButton } from '@shared/buttons';
import CustomModal from '@shared/components/modal/CustomModal';
import {
  CloseIcon,
} from '@shared/icons';

import './DeleteAttachmentModalStyle.scss';

type DeleteAttachmentModalProps = {
  open: boolean;
  toggle: (e: any) => void;
  payload: any;
};

const i18n = LocaleService.getTranslations('messages.modal.delete');

const DeleteAttachmentModal = ({
  open, toggle, payload,
}: DeleteAttachmentModalProps) => {
  const dispatch = useDispatch<any>();
  const location = useLocation();
  const isReferral = location.pathname.includes('referral-messages');
  const [ loading, setLoading ] = useState(false);

  const onDelete = async () => {
    setLoading(true);
    try {
      if (isReferral) {
        const request = payload?.attachment_id ? deleteReferralMessageAttachmentRequest
          : deleteReferralAttachmentRequest;
        await dispatch(request(payload)).$promise;
        return;
      }
      const request = payload?.attachment_id ? deleteLabOrderMessageAttachmentRequest
        : deleteLabOrderAttachmentRequest;
      await dispatch(request(payload)).$promise;
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
      toggle(false);
    }
  };

  return (
    <CustomModal
      open={open}
      toggle={() => toggle(false)}
      noFooter
      noHeader
      modalProps={{ centered: true, id: 'message-attachment-delete-modal', className: 'modal-lg' }}
    >
      <div className="message-attachment-delete-modal-container">
        <Row className="mb-4">
          <Col xs={10}>
            <span
              className="delete-modal-title"
            >
              {i18n.title}
            </span>
          </Col>
          <Col xs={2} className="text-end">
            <a
              aria-label="Close"
              role="button"
              href="#"
              onClick={(e: any) => {
                e.preventDefault();
                toggle(false);
              }}
            >
              <CloseIcon />
            </a>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <span className="delete-modal-description">
              {i18n.description}
            </span>
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <CustomButton
              id="btn-back-modal-cancel"
              disabled={loading}
              style={{ width: '-webkit-fill-available' }}
              color="secondary"
              className="btn-lg cancel-btn-style"
              onClick={() => toggle(false)}
            >
              {i18n.button.cancel.label}
            </CustomButton>
          </Col>
          <Col xs={6}>
            <CustomButton
              id="btn-update-modal-cancel"
              loading={loading}
              disabled={loading}
              style={{ width: '-webkit-fill-available' }}
              color="primary"
              className="btn-lg delete-btn-style"
              onClick={onDelete}
            >
              {i18n.button.delete.label}
            </CustomButton>
          </Col>
        </Row>
      </div>
    </CustomModal>
  );
};

export default DeleteAttachmentModal;
